export default [
  {
    path: '/admin/payment-vendors',
    name: 'payment-vendor',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/payment/index')
  }
]
